import { render } from "./layout-base.vue?vue&type=template&id=3935d93b"
import script from "./layout-base.vue?vue&type=script&lang=js"
export * from "./layout-base.vue?vue&type=script&lang=js"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__